import React, { useState, useEffect } from 'react';
import { icons } from '../../helpers/constants';

const TimeSelection = ({ selected = false, onClick, children, className = "" }) => {
    useEffect(() => {
    
    },[])
    return(
        <>
            <div 
                className={`${className} cursor-pointer d-flex align-items-center justify-content-center ${selected ? "bg-grey-blue" : "bg-grey"} rounded8 px-2 py-1`} 
                onClick={onClick}
            >  
                <label className={`cursor-pointer btn-text bold ${selected ? "white" : "dark_grey"}`}>
                    {children}
                </label>
            </div>
        </>
    )
}

export default TimeSelection;